import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import PolicyNumber from '../../coverNoteCVComponent/policyNumber/PolicyNumber';

const PolicyNumberSection = (props) => {
  return (
    <div className="ebaoUtil__Top-Bottom-Line">
      <FormGroup controlId="">
        <Col componentClass={ControlLabel} sm={6}>
          <PolicyNumber
            policyNumber={props.coverNoteCv.excessDetail.policyNumber}
            handleChangePolicyNumber={props.handleChangePolicyNumberSection}
            isPolicyNumberRequired={props.coverNoteCv.coverNoteEntry.transactionType === 'renewal' || props.coverNoteCv.coverNoteEntry.transactionType === 'endorsement' || props.coverNoteCv.coverNoteEntry.transactionType === 'extension'}
          />
        </Col>
        <Col sm={6} />
      </FormGroup>
    </div>
  )
}

PolicyNumberSection.propTypes = {
  coverNoteCv: PropTypes.object,
  handleChangePolicyNumberSection: PropTypes.func,
};

export default PolicyNumberSection;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/policyNumberSection/PolicyNumberSection.js